import { type CommonAction, response, success } from "@iflyrpa/share";
import type { ActiomCommonParams, Toutiao } from "../../types";
import { Http } from "../../utils/http";

export interface SearchToutiaoUserIDParams extends ActiomCommonParams {
    UserName: string;
}

export type PublishAction = CommonAction<SearchToutiaoUserIDParams, Toutiao.SuggestWords[]>;

export const searchToutiaoUserInfo: PublishAction = async (_task, params) => {
    const http = new Http({
        headers: {
            cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            referer: "https://mp.toutiao.com/profile_v4/graphic/publish",
        },
    });

    const res = await http.api<{
        err_no: number;
        error_msg: string;
        data: {
            suggest: {
                user: {
                    info: { user_id: number; name: string; avatar_url: string };
                    relation_count: { followers_count: number };
                };
            }[];
        };
    }>({
        method: "get",
        url: "https://mp.toutiao.com/ugc/publish/post/v1/suggest/",
        params: {
            words: params.UserName,
            language: "zh",
            app_name: "toutiao_mp",
        },
    });

    if (res.err_no === 0) {
        return success(
            res.data.suggest.map((item) => ({
                user_id: item.user.info.user_id,
                name: item.user.info.name,
                avatar_url: item.user.info.avatar_url,
                followers_count: item.user.relation_count.followers_count,
            })),
            "搜索成功",
        );
    }

    const isSuccess = res.err_no === 0;
    const message = `搜索头条用户ID成功${isSuccess ? "成功" : `失败，原因：${res.error_msg}`}`;
    const data = isSuccess
        ? res.data.suggest.map((item) => ({
              user_id: item.user.info.user_id,
              name: item.user.info.name,
              avatar_url: item.user.info.avatar_url,
              followers_count: item.user.relation_count.followers_count,
          }))
        : [];

    return response(isSuccess ? 0 : 414, message, data);
};
